/**
 * Format price in KES (or supplied currency).
 * Prices are stored as whole numbers (e.g. 850 = KES 850).
 */
export function formatPrice(price, currency = 'KES') {
  return `${currency} ${Number(price).toLocaleString()}`;
}

/**
 * Generate a WhatsApp order link.
 * @param {string} phone – restaurant WhatsApp number (with country code, no +)
 * @param {object} product – { title, price }
 */
export function whatsappOrderLink(product, phone = '254700000000') {
  const message = encodeURIComponent(
    `Hi! I'd like to order:\n\n*${product.title}* — KES ${product.price}\n\nPlease confirm availability. Thank you!`
  );
  return `https://wa.me/${phone}?text=${message}`;
}

/**
 * Slugify a string.
 */
export function slugify(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/**
 * Debounce a function.
 */
export function debounce(fn, ms = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}
